<template>
  <div
    class="ipad-learning-process-wrapper"
    :style="{ top: `${top}px`, left: `${left}px`, right: `${left}px` }"
  >
    <!-- <h3 class="title">学习目标</h3>
    <p class="total-score">{{ parseInt(totalLoNum)}}</p>
    <div class="process">
      <div class="active" :style="{width: `${parseInt(currentPercent)}%`}">
        <div class="current-process">
          <h4>已学习</h4>
          <p>{{ parseInt(knowledgeInfo.studyLoNum) }}</p>
        </div>
      </div>
    </div>
    <div class="right-rate">
      <h3 class="title">当前阶段：</h3>
      <p class="current-stage">{{ rightAnswerRate.curStageName }}</p>
      <div class="rate">
        <h3 class="title">正答率</h3>
        <p class="num">{{ parseInt(rightAnswerRate.rightRate * 100) }}<span>%</span></p>
      </div>
    </div> -->
    
      <h3 class="title" v-if="chapterType != 5">已学会的知识点</h3>
      <div class="learning-process-tips" v-if="chapterType != 5">{{ parseInt(knowledgeInfo.studyLoNum) }}</div>
      <div class="current-process" v-if="chapterType != 5">
        <sl-steps direction="horizontal">
          <!-- <sl-step space="25%" v-for="item in dataList" 
              :key="item.crystalGear"
              :class="{ 'is-sucess': currentPercent >= item.crystalValue}">
                <div class="process-left tips">{{ item.crystalValue + '%' }}</div>
                <div class="crystal crystal-num">
                  <img src="./images/diamond.png" width="20" alt="">
                  <span class="num-text">x{{ item.crystalNum }}</span>
                </div>

                <div class="crystal-num" v-if="currentPercent >= item.crystalValue}">
                  <i class="crystal-avator"></i>
                  <span class="crystal-text">x{{ item.crystalNum }}</span>
                </div>
                <div v-else class="crystal-test">x50</div>
              </sl-step> -->
          <sl-step space="25%" v-for="item in dataList"
            :key="item.crystalGear"
            :class="{ 'is-sucess': currentPercent >= item.crystalValue }">
            <div class="crystal-num" v-if="currentPercent >= item.crystalValue ">
              <i class="crystal-avator"></i>
              <span class="crystal-text">x{{ item.crystalNum }}</span>
            </div>
            <div v-else class="crystal-test">x{{ item.crystalNum }}</div>
          </sl-step>
          
          <div class="line-hightlight" :style="{ width: currentPercent + '%' }"></div>
        </sl-steps>
      </div>
    
    <div class="rate">
      <h3 class="title">正答率</h3>
      <p class="num">{{ parseInt(rightAnswerRate.rightRate * 100) }}<span>%</span></p>
    </div>
  </div>
</template>

<script>
import slStep from "@/components/Step/slStep"
import slSteps from "@/components/Step/slSteps"
import crystalData from '../dispose'
import { getUserLocalData } from "@/utils/auth";
export default {
  name: "IpadLearningProcess",
  data() {
    return {
      dataList: []
    };
  },
  components: {
    slStep, slSteps
  },
  props: {
    top: {
      type: Number,
      default: 80
    },
    left: {
      type: Number,
      default: 22
    },
    knowledgeInfo: {
      type: Object
    },
    totalScore: {
      type: Number,
      default: 0
    },
    currentScore: {
      type: Number,
      default: 0
    },
    chapterType: Number | String,
    rightAnswerRate: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },
  computed: {
    currentPercent() {
      let { unlockLoNum,studyLoNum } = this.knowledgeInfo
      // let { unlockLoNum } = this.knowledgeInfo
      let per
      if (parseInt(studyLoNum) > 0) {
        let { allPoint } = getUserLocalData()
        let perPoint = allPoint ? allPoint : unlockLoNum
        per = Math.round((parseInt(studyLoNum)/parseInt(perPoint)).toFixed(2) * 100)
        return per
      } else {
        return 0
      }
    },
    totalLoNum() {
      let unlockLoNum = this.knowledgeInfo.unlockLoNum?parseInt(this.knowledgeInfo.unlockLoNum):0
      return unlockLoNum
    }
  },
  created(){
    const res = crystalData()
    this.dataList = res.reverse()

  },
  mounted(){},
  methods: {}
};
</script>

<style lang="scss" scoped>
.ipad-learning-process-wrapper {
  height: 54px;
  font-size: 14px;
  font-family: PingFangSC-Semibold, PingFang SC;
  text-align: center;
  background: url("./images/process-bg.png") no-repeat;
  background-size: 100% 100%;
  box-sizing: border-box;
  position: absolute;
  z-index: 99;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  h3 {
    color: rgba(0, 255, 249, 1);
    font-weight: 600;
    line-height: 20px;
    margin-left: 28px;
  }
  .total-score, .current-stage, .rate .num {
    font-size: 16px;
    font-weight: 600;
    color: rgba(0,255,249,1);
    line-height: 28px;
    margin: 0 10px;
  }
  .current-stage {
    font-size: 14px;
  }
  .current-stage {
    margin: 0;
  }
  .process {
    width: 189px;
    height: 18px;
    background: url("./images/process.png") no-repeat;
    background-size: contain;
    box-sizing: border-box;
    position: relative;
    .active {
      height: 100%;
      background: url("./images/process-active.png") no-repeat;
      background-size: cover;
      background-position: left center;
      position: absolute;
      bottom: 0;
      left: 0;
      .current-process {
        font-family:Helvetica;
        width: 86px;
        height: 27px;
        text-align: center;
        background: url("./images/info-dialog.png") no-repeat;
        background-size: contain;
        position: absolute;
        top: -27px;
        left: -33px;
        padding-left: 4px;
        display: flex;
        align-items: center;
        padding-bottom: 4px;
        box-sizing: border-box;
        h4 {
          font-size:12px;
          color:rgba(0,255,249,1);
          line-height:16px;
        }
        p {
          color:rgba(0,255,249,1);
          line-height:16px;
        }
      }
    }
  }
  .right-rate {
    flex: 1 1 auto;
    display: flex;
    align-items: center;
    h3 {
      margin-left: 20px;
    }
    .rate {
      flex: 1 1 auto;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      margin-right: 20px;
    }
  }
  .learning-process-tips {
    font-size:14px;
    font-family:PingFangSC-Medium,PingFang SC;
    font-weight:500;
    color:rgba(255,255,255,1);
    line-height:20px;
    background:rgba(0,178,255,1);
    border-radius:4px;
    width:38px;
    height:20px;
    margin-left: 4px;
  }
  .current-process {
    width: 430px;
    .line-hightlight {
      position: absolute;
      left: 0;
      top: -1px;
      height: 4px;
      background:linear-gradient(180deg,rgba(0,255,248,1) 0%,rgba(0,178,255,1) 100%);
      border-radius:3px;
      transition: height .5s;
    }
  }
  .rate {
    // width: 120px;
    flex: 0 0 auto;
    display: flex;
    align-items: center;
    margin-left: auto;
    h3.title {
      margin-left: 0;
      line-height: auto;
    }
    p.num {
      line-height: auto;
    }
  }
}
@media screen and (max-width: 960px) {
  .ipad-learning-process-wrapper {
    .current-process {
      width: 400px;
    }
  }
}
@media screen and (max-width: 569px) {
  .ipad-learning-process-wrapper {
    .current-process {
      width: 300px;
    }
    h3 {
      margin-left: 2px;
      font-size: 12px;
      font-weight: normal;
    }
    .rate {
      p.num {
        margin: 0;
         padding-left:2px; 
         font-size: 12px;
        span {
         
        }
      }
    }
  }
}
@media screen and (min-width:569px) and (max-width:680px){
  .ipad-learning-process-wrapper {
    .current-process {
      width: 330px;
    }
    h3 {
      margin-left: 10px;
    }
  }
}
</style>
<style lang="scss">
  .ipad-learning-process-wrapper {
    .current-process {
      margin-left: 4px;
      .sl-step_head {
        width: 100%;
        // display: flex;
        position: relative;
        .sl-step_line {
          height:2px;
          background:rgba(0,178,255,1);
          border-radius:3px;
        }
        .sl-step_icon {
          width:20px;
          height:20px;
          background:rgba(20,91,149,1);
          border:2px solid rgba(0,178,255,1);
          border-radius: 100%;
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          right: 0;
          &:after {
            content: '';
            width: 18px;
            height: 18px;
            background-image: url(./images/diamond.png);
            background-size: cover;
            background-repeat: no-repeat;
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
          }
        }
      }
      .crystal-test {
        font-size:12px;
        width: 36px;
        font-family:PingFangSC-Medium,PingFang SC;
        font-weight:500;
        color:rgba(255,255,255,1);
        line-height:17px;
        position: absolute;
        right: -50px;
        transform: translateX(-50%);
        top: -17px;
      }
      .sl-step {
        &.is-sucess {
          .sl-step_head {
           .sl-step_icon {
             border: none;
             width:15px;
            height:15px;
            background:rgba(0,255,249,1);
            border:2px solid rgba(0,255,249,1);
            border-radius: 100%;
            filter:blur(2px);
            &:after {
              background-image: none;
            }
           }
          }
          .crystal-num {
            position: absolute;
            display: flex;
            align-items: center;
            right: -18px;
            top: -22px;
            i.crystal-avator {
              width: 18px;
              height: 18px;
              background-image: url(./images/diamond.png);
              background-size: cover;
              background-repeat: no-repeat;
              flex: 0 0 auto;
            }
            .crystal-text {
              font-size: 14px;
              color:rgba(0,255,249,1);
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/IpadLearningProcess/index.vue